import type { Style } from './style';
import { AMAPIANO } from './styles/amapiano';
import { ASAKAA } from './styles/asakaa';
import { AZONTO } from './styles/azonto';
import { GOSPEL } from './styles/gospel';
import { HIGHLIFE } from './styles/highlife';
import { HIPLIFE } from './styles/hiplife';

export interface SynthStation {
  id: string;
  name: string;
  genre: string;
  style: Style;
}

/** Built-in stations, generated live. Made-up names; no real station is imitated. */
export const SYNTH_STATIONS: readonly SynthStation[] = [
  { id: 'highlife', name: 'Palm Wine FM', genre: 'Highlife', style: HIGHLIFE },
  { id: 'hiplife', name: 'Circle Hiplife', genre: 'Hiplife', style: HIPLIFE },
  { id: 'azonto', name: 'Azonto Station', genre: 'Azonto', style: AZONTO },
  { id: 'amapiano', name: 'Osu Amapiano', genre: 'Amapiano', style: AMAPIANO },
  { id: 'asakaa', name: 'Asakaa Drill', genre: 'Kumasi drill', style: ASAKAA },
  { id: 'gospel', name: 'Sunday Service', genre: 'Gospel', style: GOSPEL },
];
